// 每次请求 都检查 token
export default function httpInterceptor($q) {
    'ngInject'

    // return $resource('/common/data/appInfo.json');
    return {
        request(config) {
            const token = localStorage.getItem('id_token')
            if (token && config.url.split('/')[config.url.split('/').length - 1] !== 'loginFat') {
                config.headers.accessToken = token
            }
            config.headers.webAnchors = localStorage.getItem('currentStateName')
            return config
        },
        requestError(err) {
            return $q.reject(err)
        },
        response(res) {
            // 判断为分页器的请求时，在数据返回渲染结束后去掉被禁用a标签的href属性，解决ie11问题
            if (res.data.value) {
                if (res.data.value.pageNum) {
                    setTimeout(() => {
                        $('a[disabled]').removeAttr('href')
                    }, 300)
                }
            }
            return res
        },
        responseError(err) {
            console.log(err)
            return $q.reject(err)
        },
    }
}



// WEBPACK FOOTER //
// ./src/common/factory/httpInterceptor.js